import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import InboxStateContext from "./InboxStateContext";

const useInboxStateContext = () => useDefinedContext(InboxStateContext, "InboxStateContext");

export default useInboxStateContext;
